import React from 'react';
import { Button, Form, FormGroup, Input, Label, Table } from 'reactstrap';

class CellDecoder extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
            file: null,
            results: null,
        }
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.dismissError = this.dismissError.bind(this);
    }

    handleFileChange(event) {
        this.setState({ file: event.target.files[0] });
    }

    async handleSubmit(event) {
        event.preventDefault();
        
        const { file } = this.state;
        if (!file) {
            this.setState({ errors: [{ title: "Upload Error", text: "No file uploaded" }] });
            return;
        }
        this.setState({ loading: true });
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch('http://localhost:8000/api/cell_decoder', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const results = await response.json();
            this.setState({ results, loading: false });
        } catch (error) {
            this.setState({
                errors: [{ title: "Processing Error", text: error.message }],
                loading: false
            });
        }
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }
 
    render() {
        const { errors, loading, results } = this.state;
        return (
            <div className="cell-decoder-container">
                <h1>Cell Decoder</h1>
                <Form onSubmit={this.handleSubmit} className="cell-decoder-form">
                    <FormGroup className="file-input-group">
                        <Label for="fileInput">Insert File:</Label>
                        <Input type="file" name="file" id="fileInput" onChange={this.handleFileChange} />
                        <Button type="submit">Process File</Button>
                    </FormGroup>
                    
                    {loading && <div>Loading...</div>}
                    
                    {results && (
                        <div>
                            <h3>Results:</h3>
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Command</th>
                                        <th>Error</th>
                                        <th>Process</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {results.map((result, index) => (
                                        <tr key={index}>
                                            <th scope="row">{index + 1}</th>
                                            <td>{result.Command}</td>
                                            <td>{result.Error}</td>
                                            <td>{result.Process}</td>
                                            <td>{result.Description}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {errors.map((error, idx) => (
                        <div key={`error-${idx}`} className="error-message">
                            <h4>{error.title}</h4>
                            <p>{error.text}</p>
                            <Button onClick={() => this.dismissError(error)}>Dismiss</Button>
                        </div>
                    ))}
                </Form>
            </div>
        );
    }
}

export default CellDecoder;


// WEBPACK FOOTER //
// ./src/components/pages/utilities/CellDecoder.js